import type { VariantProps } from "class-variance-authority"
import type { ReactNode } from "react"
import React from "react"
import { cva } from "class-variance-authority"

import { cn } from "@productlane/lib/src/browser"

export const variantStyles = cva("p-1", {
	variants: {
		variant: {
			error: "text-red-600 dark:text-red-400",
			success: "text-green-500 dark:text-green-500",
			gray: "text-secondary",
			primary: "text-brand-600 dark:text-brand-400",
			warning: "text-amber-600 dark:text-amber-400",
			link: "text-[var(--portal-accent-color)]",
		},
	},
	defaultVariants: {
		variant: "gray",
	},
})

interface Props extends VariantProps<typeof variantStyles> {
	icon: ReactNode
}

export const IconWithHalo = React.memo(({ icon, variant }: Props) => (
	<div className={cn("", variantStyles({ variant }))}>{icon}</div>
))
